import * as React from "react";
import { GridWrapper } from "../../integrations/UoE-Grid/GridWrapper";
import "../../assets/css/AOS2/AOS2_Agent_Access_Page.css";
import { useApi } from "../../Providers/ApiProvider";
import { useLoaderData, useParams } from "react-router-dom";
import IfPermitted from "../IfPermitted";
import BarGraph from "./Visualisation/BarGraph";
import BarGraphStacked from "./Visualisation/BarGraphStacked";

export default function AOS2_ADMIN_Agent_Access() {
  let agtno = useLoaderData();
  let [agentname, setAgentName] = React.useState<string>(
    agtno.toString() ?? "",
  );
  let [agentnameInput, setAgentnameInput] = React.useState<string>(
    agtno.toString() ?? "",
  );
  let api = useApi();
  let [data, setData] = React.useState();
  let [UGdata, setUGdata] = React.useState([]);
  let [PGdata, setPGdata] = React.useState([]);
  let [TotalData, setTotalData] = React.useState([]);
  let [widthGraph, setWidthGraph] = React.useState<number>(928);
  let [heightGraph, setHeightGraph] = React.useState<number>(500);
  let [accessData, setAccessData] = React.useState([]);
  let [multiAccessData, setMultiAccessData] = React.useState([]);

  React.useEffect(() => {
    api.General.get(
      "/sproc",
      JSON.stringify({
        sproc: "sputilities.webui.AOSv2_ADMIN_AgentURLAccessTotal",
        params: ["@AGENT", agentname],
      }),
    ).then((respData) => {
      setData(respData);
    });
  }, [agentname]);

  // set data shape for single colour barchart
  React.useEffect(() => {
    api.General.get(
      "/sproc",
      JSON.stringify({
        sproc: "sputilities.webui.AOSv2_ADMIN_AgentPageVisitbyMonth",
        params: ["@AGENTNAME", agentname],
      }),
    )
      .then((respData) => {
        setData(respData);
        setAccessData([]);
        // shape data into date:number
        for (let i = 0; i < respData[0].length; i++) {
          for (const [key, value] of Object.entries(respData[0][i])) {
            if (key === "Year") {
              var yearValue = parseInt(value.toString());
            } else if (key === "Total") {
            } else {
              let monthNumber = new Date(`1-${key}-2025`).getMonth();
              var dash;
              if (value === "-") {
                dash = 0;
              } else {
                dash = parseInt(value.toString());
              }
              setAccessData((old) => {
                old.push({
                  label: new Date(yearValue, monthNumber),
                  val: dash,
                });
                return [...old];
              });
            }
          }
        }
      })
      .catch((rejects) => {
        setAccessData([]);
      });
  }, [agentname]);

  // set data shape for Multi colour barchart
  React.useEffect(() => {
    api.General.get(
      "/sproc",
      JSON.stringify({
        sproc: "sputilities.webui.AOSv2_ADMIN_AgentURLAccessUGPG",
        params: ["@AGENTNAME", agentname],
      }),
    )
      .then((respData) => {
        setData(respData);
        setMultiAccessData([]);
        //console.log("MAD-rd:", respData);

        interface RespDataItem {
          Year: string;
          "Access Type": string;
          January: string;
          February: string;
          March: string;
          April: string;
          May: string;
          June: string;
          July: string;
          August: string;
          September: string;
          October: string;
          November: string;
          December: string;
          Total?: string;
        }

        // This returns (Date:date, PG:number, UG:number, Other:number, Total: number)

        // interface TransformedRow {
        //   date: Date;
        //   PG: number;
        //   UG: number;
        //   Other: number;
        //   Total: number;
        // }

        // const knownTypes = ['PG', 'UG'];
        // const combinedMap: Record<string, Omit<TransformedRow, 'Total'>> = {};

        // respData[0].forEach((entry: RespDataItem) => {
        //   const year = entry.Year;
        //   const type = entry["Access Type"];
        //   if (type === "Total" || type === "---") {
        //     return;
        //   }
        //   // Only use type if it's exactly 'PG' or 'UG', else fall back to 'Other'
        //   const resolvedType = knownTypes.includes(type) ? type : 'Other';

        //   Object.entries(entry).forEach(([monthName, value]) => {
        //     if (["Year", "Access Type", "Total"].includes(monthName)) return;
        //     if (value === '-' ) {value = 0}
        //     if (value === '---') return;

        //     const numericValue = parseInt(value, 10);
        //     if (isNaN(numericValue)) return;

        //     const monthNumber = new Date(`1-${monthName}-2025`).getMonth();
        //     const dateKey = `${year}-${String(monthNumber + 1).padStart(2, '0')}`;

        //     if (!combinedMap[dateKey]) {
        //       combinedMap[dateKey] = {
        //         date: new Date(Number(year), monthNumber, 1),
        //         PG: 0,
        //         UG: 0,
        //         Other: 0
        //       };
        //     }

        //     combinedMap[dateKey][resolvedType as 'PG' | 'UG' | 'Other'] += numericValue;
        //   });
        // });

        // // Add Total field
        // const transformedData: TransformedRow[] = Object.values(combinedMap).map(row => ({
        //   ...row,
        //   Total: row.PG + row.UG + row.Other
        // }));

        interface OutputRow {
          date: Date;
          level: "PG" | "UG" | "Other" | "Total";
          val: number;
        }

        const knownTypes = ["PG", "UG"];
        const combinedMap: Record<
          string,
          { date: Date; PG: number; UG: number; Other: number }
        > = {};

        respData[0].forEach((entry: RespDataItem) => {
          const type = entry["Access Type"];

          // Skip rows with invalid types
          if (type === "Total" || type === "---") return;

          const year = entry.Year;
          const resolvedType = knownTypes.includes(type) ? type : "Other";

          Object.entries(entry).forEach(([monthName, value]) => {
            if (["Year", "Access Type", "Total"].includes(monthName)) return;
            if (value === "-") {
              value = 0;
            }
            if (value === "---" || type === "Total") return;

            const numericValue = parseInt(value, 10);
            if (isNaN(numericValue)) return;

            const monthNumber = new Date(`1-${monthName}-2025`).getMonth(); // parse month safely
            const dateKey = `${year}-${String(monthNumber + 1).padStart(2, "0")}`;

            if (!combinedMap[dateKey]) {
              combinedMap[dateKey] = {
                date: new Date(Number(year), monthNumber, 1),
                PG: 0,
                UG: 0,
                Other: 0,
              };
            }

            combinedMap[dateKey][resolvedType as "PG" | "UG" | "Other"] +=
              numericValue;
          });
        });

        // Flatten into OutputRow[]
        const transformedData: OutputRow[] = [];

        Object.values(combinedMap).forEach((row) => {
          const { date, PG, UG, Other } = row;
          const total = PG + UG + Other;

          transformedData.push(
            { date, level: "PG", val: PG },
            { date, level: "UG", val: UG },
            { date, level: "Other", val: Other },
            // { date, level: 'Total', val: total }
          );
        });

        //console.log("pre value:",transformedData);
        //console.log("trans:", transformedData);

        setMultiAccessData(transformedData);
        //console.log("new attempt:", multiAccessData);
      })
      .catch((rejects) => {
        setMultiAccessData([]);
      });
  }, [agentname]);

  // handle window resize for width/height of graph
  (React.useEffect(() => {
    function handleResize() {
      if (window.innerWidth - 100 < 928) {
        const gWidth = window.innerWidth * 0.85;
        setWidthGraph(gWidth);
      } else {
        setWidthGraph(928);
      }
    }
    window.addEventListener("resize", handleResize);
  }),
    [widthGraph]);

  return (
    <div className="AOS2_ADMIN_Agent_Access">
      <h2>Agent Access AOS Tracker</h2>
      <div className="RequestRow">
        <label className="inputLabel" htmlFor="AgentValue">
          Agent User Name:
        </label>
        <input
          className="UserNameInput"
          id="UserNameInput"
          type="text"
          value={agentnameInput}
          onChange={(e) => {
            setAgentnameInput(e.target.value);
          }}
        />
        <input
          id="submit"
          type="button"
          value="Search"
          onClick={() => {
            setAgentName(agentnameInput);
          }}
        />
      </div>
      <div className="JustASpacer"></div>
      <div className="JustASpacer"></div>

      <div className="AgentsTotalAccess">
        <h3>AOS visits per Month</h3>
        <div className="JustASpacer"></div>
        <div className="JustASpacer"></div>
        <GridWrapper
          eid={"Agent_page_access_values"}
          sproc="sputilities.webui.AOSv2_ADMIN_AgentPageVisitbyMonth"
          params={["@AGENTNAME", agentname]}
          Callouts={false}
          URLParams={""}
        ></GridWrapper>
        <div className="JustASpacer"></div>
        <BarGraph data={accessData} width={widthGraph} />
        <div className="JustASpacer"></div>
      </div>

      <div className="AgentsLevelTable">
        <h3>AOS visits per Month Separated by UG or PG</h3>
        <div className="JustASpacer"></div>
        <div className="JustASpacer"></div>
        <GridWrapper
          eid={"Agent_page_access_ugpg"}
          sproc="sputilities.webui.AOSv2_ADMIN_AgentURLAccessUGPG"
          params={["@AGENTNAME", agentname]}
          Callouts={false}
          URLParams={""}
        ></GridWrapper>
        <BarGraphStacked data={multiAccessData} width={widthGraph} />
        <div className="JustASpacer"></div>
        <div className="JustASpacer"></div>
      </div>
      <IfPermitted Whitelist={["EDRM.Owner"]}>
        <div className="IPTable">
          <h3>AOS visits by IP address (All Time)</h3>
          <div className="JustASpacer"></div>
          <div className="JustASpacer"></div>
          <GridWrapper
            eid={"Agent_page_access_ip"}
            sproc="sputilities.webui.AOSv2_ADMIN_AgentIPAccessTotal"
            params={["@AGENTNAME", agentname]}
            Callouts={false}
            URLParams={""}
          ></GridWrapper>
        </div>
      </IfPermitted>
    </div>
  );
}
